/**
 * Formata datas "somente dia" (vencimento, validade) persistidas como
 * meia-noite UTC. `new Date()` + formatação local deslocaria para o dia
 * anterior em fusos negativos (ex.: America/Sao_Paulo).
 */
export const formatDateOnly = (value: string | Date): string => {
    const iso = value instanceof Date ? value.toISOString() : value
    const [year, month, day] = iso.slice(0, 10).split('-')
    return `${day}/${month}/${year}`
}
